import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';
import { getListAssignedLearning } from '../api/platform';

export interface IDataCoursesList {
  date?: string;
  assignment?: boolean;
  token_1: string;
  token_2: string;
  course_id: number;
  campaign_id?: number;
  status: number;
  training_status: number;
  end_date?: string;
  start_date?: string;
  tp_id?: number;
  tp_thumbnail?: string;
  course_name?: string;
  latest_score: string;
  student_id?: number;
  tp_name?: string;
  training_label: string;
  assigned_course_again: number;
  has_certificate: number;
  phish_id?: number | null;
  course_category_name?: string;
}

export interface IDataCourses {
  pending_status: number;
  completed_status: number;
  course_list: IDataCoursesList[];
}

export interface GetAssignedLearningListObjectState {
  dataAssignedCourse: {
    pending_status: number;
    completed_status: number;
    course_list: IDataCoursesList[];
  };
  isLoading: boolean;
  error?: string;
}

const initialState: GetAssignedLearningListObjectState = {
  dataAssignedCourse: {
    pending_status: 0,
    completed_status: 0,
    course_list: []
  },
  isLoading: false,
  error: undefined
};

export const getAssignedLearningListEvents = createAsyncThunk(
  'getAssignedLearningListEventPlatform',
  async (param: string) => {
    const response = await getListAssignedLearning(param);
    return response ? response : initialState;
  }
);

export const getAssignedLearningListSlice = createSlice({
  name: 'getAssignedLearningListEvents',
  initialState,
  reducers: {
    setAssignedLearningListEventData: (state, action: PayloadAction<IDataCourses>) => {
      state.isLoading = false;
      state.dataAssignedCourse = action.payload;
      state.error = undefined;
    },
    removeAssignedLearningListEvent: (state) => {
      state.isLoading = false;
      state.dataAssignedCourse = initialState.dataAssignedCourse;
      state.error = undefined;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getAssignedLearningListEvents.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(
      getAssignedLearningListEvents.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.dataAssignedCourse = action.payload;
        state.error = undefined;
      }
    );

    builder.addCase(getAssignedLearningListEvents.rejected, (state, action) => {
      state.isLoading = false;
      state.dataAssignedCourse = initialState.dataAssignedCourse;
      state.error = action.payload as string;
    });
  }
});

export const { setAssignedLearningListEventData, removeAssignedLearningListEvent } =
  getAssignedLearningListSlice.actions;

export const getAssignedLearningListEventsDataSelector = (state: RootState) =>
  state.getAssignedLearningListEvents;
export default getAssignedLearningListSlice.reducer;
